import React from 'react';
import cx from 'classnames';

import { Asset as ContentfulAsset } from 'contentful';

import { IImageWith7030TextFields } from '../../../types/contentful';

import RichText from '../RichText';
import { Asset } from '../AtomicComponents/Asset';

export function ImageWith7030TextEmbed({
  image,
  headingText,
  imageFirst,
  bodyCopy
}: IImageWith7030TextFields) {
  const isImageFirst = imageFirst || false;
  return (
    <div
      className={cx(
        'flex',
        isImageFirst
          ? 'flex-col tablet:flex-row'
          : 'flex-col-reverse tablet:flex-row-reverse'
      )}
    >
      <div
        className={cx(
          'flex flex-[1_0_auto] tablet:flex-[1_0_66.666%]',
          isImageFirst ? 'pb-0' : 'pb-6',
          'tablet:pb-0',
          isImageFirst ? 'pt-0' : 'pt-6',
          'tablet:pt-0',
          'pl-0',
          isImageFirst
            ? 'tablet:pl-0 desktop:pl-0'
            : 'tablet:pl-6 desktop:pl-12',
          isImageFirst
            ? 'tablet:pr-6 desktop:pr-12'
            : 'tablet:pr-0 desktop:pr-0'
        )}
      >
        <div
          className="w-full tablet:w-auto tablet:flex-[1.5]"
          data-blockid="imageWith7030Text-image"
        >
          <Asset
            asset={image as ContentfulAsset}
            loading="eager"
            className="mx-auto block max-w-full flex-[1_0_auto] rounded-[64px] desktop:rounded-[104px]"
          />
        </div>
      </div>
      <div className="flex w-[83.333%] items-center self-center tablet:w-auto tablet:flex-[1_0_33.334%] tablet:self-auto">
        <div className="w-full tablet:w-auto tablet:flex-1">
          <div className="mb-3 pt-0 tablet:pt-4">
            <h3
              className="text-[22px] font-medium leading-6 tablet:text-[26px] tablet:leading-8"
              data-blockid="imageWith7030Text-headline"
            >
              {headingText}
            </h3>
          </div>
          {bodyCopy && (
            <div data-blockid="imageWith7030Text-subhead">
              <RichText data={bodyCopy} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
